import { Container, Heading, Text } from '@chakra-ui/react';
import AuthWarningText from 'presentation/components/modules/login/AuthWarningText';
import AppCard from 'presentation/components/shared/card/AppCard';
import { headerHeight } from 'presentation/layout/shared/Header/Header';
import { FontSize } from 'presentation/theme/fontSizes';
import { FC, PropsWithChildren } from 'react';
import { useWindowSize } from 'react-use';

interface Props extends PropsWithChildren {
  title: string;
  hint?: string | null;
}

const LoginTemplate: FC<Props> = ({ title, hint, children }) => {
  const { height } = useWindowSize();

  return (
    <Container
      display="flex"
      flexDir="column"
      alignItems="center"
      minH={height - headerHeight}
      justifyContent="space-between"
      pt="15vh"
      pb="10vh"
    >
      <AppCard w={{ md: '450px', base: '100%' }} pt="30px" px="30px" pb="40px" mb="30px">
        <Heading fontSize={FontSize.xl} as="h3" mb="10px" textAlign="center">
          {title}
        </Heading>
        <Text mb="20px" visibility={hint ? 'visible' : 'hidden'} textAlign="center">
          {hint ?? 'text'}
        </Text>
        {children}
      </AppCard>
      <AuthWarningText />
    </Container>
  );
};

export default LoginTemplate;
